import type { Environment } from "../../types";

/**
 * ONEpop 서비스 웹의 랜딩 페이지. 화면의 버튼/배너는 전부 이 페이지들로의
 * 이동이라 disabled 상태가 없다 — 노출 여부만 API 응답으로 정한다.
 *
 * 공개 랜딩은 `send`(루트)와 `board`뿐이고 `claim`/`activity`는 서비스 안에서
 * 로그인(X 연결)을 요구하는 noindex 페이지지만, 접근 제어는 서비스 몫이므로
 * 여기서는 단순 딥링크만 만든다.
 */
export type OnePopLandingPage = "send" | "claim" | "activity" | "board";

const ONE_POP_WEB_BASE: Record<Environment, string> = {
  dev: "https://dev.onechain.nexus/pop",
  stage: "https://stg.onechain.nexus/pop",
  production: "https://onechain.nexus/pop",
};

export function onePopLandingUrl(
  env: Environment,
  page: OnePopLandingPage,
): string {
  const base = ONE_POP_WEB_BASE[env] ?? ONE_POP_WEB_BASE.production;
  return page === "send" ? base : `${base}/${page}`;
}

/**
 * "Get ONEUSD ›" 의 목적지 — 게임토큰 웹의 브리지 페이지. 게임토큰은 dev
 * 배포가 없어 dev 도 stage 를 본다(앱런처 메뉴의 gametoken 항목과 동일 규칙).
 */
const ONE_USD_BRIDGE_URL: Record<Environment, string> = {
  dev: "https://stg.onechain.nexus/gametoken/bridge",
  stage: "https://stg.onechain.nexus/gametoken/bridge",
  production: "https://www.onechain.nexus/gametoken/bridge",
};

export function oneUsdBridgeUrl(env: Environment): string {
  return ONE_USD_BRIDGE_URL[env] ?? ONE_USD_BRIDGE_URL.production;
}
